<script lang="ts" setup>
import { useConfigStore } from '~/store/useConfigStore'

const store = useConfigStore()
const { footerSocialsMenu } = storeToRefs(store)
</script>

<template>
  <div class="footer-social">
    <h3 class="footer-social__title">
      Follow us
    </h3>
    <Menu
      v-if="footerSocialsMenu"
      :menu="footerSocialsMenu"
      class="footer-social__list"
    />
  </div>
</template>

<style lang="scss" scoped>
 .footer-social {
    &__title {
      @apply text-[18px] text-white font-normal leading-[1] mb-[25px] uppercase;
    }

    &__list {
      @apply flex flex-col gap-y-[20px];
    }

    :deep(.static-url-menu-item) {
      @apply normal-case text-[18px] text-white/60 font-normal leading-[1] transition-colors duration-300;
      @apply hover:text-white;
    }
  }
</style>
